import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState} from '../store';
import {Observable} from 'rxjs';
import {getHomePageContent} from '../store/content.actions';
import {createContentResolver} from './create-content-resolver';
import {LoadingService} from '../shared/services/loading.service';


@Injectable({
  providedIn: 'root'
})
export class HomePageContentResolver  {


  constructor(
    private store:Store<AppState>,
    private loading: LoadingService) {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    const loadContent$ = createContentResolver(this.store, "homePage", getHomePageContent);

    return this.loading.showLoaderUntilCompleted(loadContent$);
  }


}
